import { render, staticRenderFns } from "./ProxyPosition.vue?vue&type=template&id=d4059244&scoped=true"
import script from "./ProxyPosition.vue?vue&type=script&lang=js"
export * from "./ProxyPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4059244",
  null
  
)

export default component.exports